import React, { useState } from 'react';
import { AiOutlineHeart, AiOutlineUser } from 'react-icons/ai';
import { FiLogOut } from 'react-icons/fi';
import { AuthPopup } from '../../auth/AuthPopUp';
import { LoginForm } from '../../auth/LoginForm';
import { SignupForm } from '../../auth/SignupForm';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { logoutUser } from '../../../api/auth.service';
import toast from 'react-hot-toast';
import CartIcon from '../../../assets/icon/cart.svg';
import CartIconBlack from '../../../assets/icon/cartIcon.svg';
import ThoorigaiLogoLight from '../../../assets/logos/thoorigai-light.svg';
import ThoorigaiLogoDart from '../../../assets/logos/Thoorigai-dark.svg';

const HeaderAuth = ({
  color,
  page,
  className = 'flex relative container mx-auto z-10 items-center px-4 md:px-4 py-4 ',
}) => {
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const [isSignupOpen, setIsSignupOpen] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector((state) => state.auth);

  const showLogin = () => {
    if (!isAuthenticated) {
      setIsSignupOpen(false);
      setIsLoginOpen(true);
    }
  };

  const showSignup = () => {
    if (!isAuthenticated) {
      setIsLoginOpen(false);
      setIsSignupOpen(true);
    }
  };

  const closeAll = () => {
    setIsLoginOpen(false);
    setIsSignupOpen(false);
  };

  const handleLogout = async () => {
    try {
      await logoutUser(dispatch);
      navigate('/');
      toast.dismiss();
      toast.success('Logout successfully');
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  const Thoorigailogo =
    color === 'black' ? ThoorigaiLogoDart : ThoorigaiLogoLight;

  return (
    <section className='container mx-auto'>
      <header className={className}>
        <div className='flex justify-between items-center w-full'>
          <div className='flex'>
            <div className='text-3xl md:text-4xl mr-8 font-bold hover:cursor-pointer'>
              <Link to='/'>
                <img
                  src={Thoorigailogo}
                  alt='thoorigai logo'
                  className='md:w-56 w-40'
                />
              </Link>
            </div>
          </div>

          <div className='flex items-center gap-4'>
            <IconLinks
              color={color}
              showLogin={showLogin}
              isAuthenticated={isAuthenticated}
              handleLogout={handleLogout}
              page={page}
            />
          </div>
        </div>

        {!isAuthenticated && (
          <>
            <AuthPopup isOpen={isLoginOpen} onClose={closeAll}>
              <LoginForm onShowSignup={showSignup} />
            </AuthPopup>

            <AuthPopup isOpen={isSignupOpen} onClose={closeAll}>
              <SignupForm onShowLogin={showLogin} />
            </AuthPopup>
          </>
        )}
      </header>
    </section>
  );
};

function IconLinks({ color, showLogin, isAuthenticated, handleLogout, page }) {
  const navigate = useNavigate();
  const hoverColor = color === 'black' ? '#333' : '#ccc';
  const cartIc = color === 'black' ? CartIconBlack : CartIcon;

  const iconStyle = {
    color: color,
    cursor: 'pointer',
    transition: 'color 0.3s',
  };

  return (
    <div className='flex gap-4 text-xl md:text-3xl font-semibold'>
      {isAuthenticated && page !== 'wishlist' && (
        <AiOutlineHeart
          title='Favorites'
          aria-label='Favorites'
          className='transition-transform hover:scale-105'
          style={iconStyle}
          onMouseEnter={(e) => (e.currentTarget.style.color = hoverColor)}
          onMouseLeave={(e) => (e.currentTarget.style.color = color)}
          onClick={() => navigate('/wishlist')}
        />
      )}
      {!isAuthenticated ? (
        <AiOutlineUser
          title='Account'
          aria-label='Account'
          className='transition-transform hover:scale-105'
          style={iconStyle}
          onClick={showLogin}
          onMouseEnter={(e) => (e.currentTarget.style.color = hoverColor)}
          onMouseLeave={(e) => (e.currentTarget.style.color = color)}
        />
      ) : (
        <>
          {page !== 'cart' && (
            <img
              src={cartIc}
              alt='cart icon'
              className='hover:scale-105 md:w-7 md:h-7 w-6 h-5 transition-transform cursor-pointer'
              onClick={() => navigate('/cart')}
            />
          )}
          <FiLogOut
            title='Logout'
            aria-label='Logout'
            className='transition-transform hover:scale-105'
            style={iconStyle}
            onMouseEnter={(e) => (e.currentTarget.style.color = hoverColor)}
            onMouseLeave={(e) => (e.currentTarget.style.color = color)}
            onClick={handleLogout}
          />
        </>
      )}
    </div>
  );
}

export default HeaderAuth;
